module.exports = __webpack_public_path__ + "static/img/title.b65fde40.png";